function ToNum(t)
{
    return parseFloat(t.substring(0, t.length - 2));
}

function update(idx)
{
    var dots = $('.dot');
    var lines = $('.line');
    var headers = $('h1, section h2:first-of-type');

    headers.splice(1, 1);

    for (var i = idx; i < dots.length; i++) {
        var dot = dots[i];
        var line = lines[i];

        if (idx === 0) {
            dot.style.top = (headers[i].getBoundingClientRect().top + scrollY + 8) + 'px';
            if (line)
                line.style.top = (headers[i].getBoundingClientRect().top + scrollY + 8 + 30) + 'px';
        } else {
            if (dot.getBoundingClientRect().top < 470) {
                if (!dot.className.includes('active')) {
                    dot.className += ' active';
                }
            } else {
                if (dot.className.includes('active')) {
                    dot.className = dot.className.substring(0, dot.className.length - 7);
                }
            }
        }
    }
}

function updateBoxesHeight()
{
    var maxHeight = 0;
    var boxes = $('#vorteile_andere .box');

    for (var i = 0; i < boxes.length; i++) {
        if (ToNum(window.getComputedStyle(boxes[i]).height) >= maxHeight ) {
            maxHeight = ToNum(window.getComputedStyle(boxes[i]).height);
        }
    }

    for (var i = 0; i < boxes.length; i++) {
        boxes[i].style.height = maxHeight + 'px';
    }
}

function updateLineHeight()
{
    var dots = $('.dot');
    var lines = $('.line');

    for (var i = 0; i < dots.length; i++) {
        if (dots[i + 1]) {
            var cur = ToNum(dots[i].style.top);
            var next = ToNum(dots[i + 1].style.top);

            lines[i].style.height = (next - 10) - (cur + 30) + 'px';
        }
    }
}

$(document).ready(function() {
    /*
     * Slick slider
     */
    $('.your-class').slick({
        dots: false,
        arrows: false,
        autoplay: false,
        slidesToShow: 4,
        infinite: true,
        slidesToScroll: 1,
        swipe: false,
        // customPaging: function(slider, i) {
        //     var title = $(slider.$slides[i]).data('title');
        //     return '<a class="slider-main__nav-btn" href="javascript:void(0);">'+title+'</a>';
        // },
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    swipe: true,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    swipe: true,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    swipe: true,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });

    /*
     * Custom mobile nav
     */
    // $(".icon-unfold").click(function(){
    //
    //     $(this).toggleClass("icon-unfold--down");
    //
    //     $(this).parents().closest('li').find('dropdown').addClass("open");
    //
    //     var dropdown = $(this).next();
    //
    //     dropdown.slideToggle();
    //
    // });

    /*
     * Fancybox
     */
    $(".fancybox").fancybox();

    var offset = 150;

    $('.navbar-nav a[href*="#"]').click(function(event) {
        event.preventDefault();

        var hash = this.hash;
        var target = $(hash);

        if (target.length == 0)
            target = $('a[name="' + hash.substr(1) + '"]');

        if (target.length == 0)
            target = $('html');

        $('html, body').animate({
            scrollTop: target.offset().top-offset
        }, 500, function() {
            if (history.pushState) {
                history.pushState(null, null, '/' + hash);
            } else {
                location.hash = hash;
            }
        });
        return false;
    });

    var checkBoxes = $(':checkbox[required]');
    checkBoxes.change(function()
    {
        if (checkBoxes.is(':checked'))
            checkBoxes.removeAttr('required');
        else
            checkBoxes.attr('required', 'required');
    });

    var points = $('#leistungsumfang span');
    var titles = points.splice(0, points.length / 4);
    var bronze = points.splice(0, points.length / 3);
    var silver = points.splice(0, points.length / 2);
    var gold = points;
    var sum = 0;

    for (var i = 0; i < titles.length; i++) {
        var height = ToNum(window.getComputedStyle(titles[i]).height);
        if (height < 60){
            titles[i].style.lineHeight = '59px';
            height = 60;
        }

        sum += height;

        bronze[i].style.lineHeight =
        silver[i].style.lineHeight =
        gold[i].style.lineHeight = height - 1 + 'px';

        titles[i].style.height =
        bronze[i].style.height =
        silver[i].style.height =
        gold[i].style.height = height + 'px';

        if (bronze[i].children.length > 0) {
            bronze[i].children[0].style.lineHeight = height + 'px';
        }
        if (silver[i].children.length > 0) {
            silver[i].children[0].style.lineHeight = height + 'px';
        }
        if (gold[i].children.length > 0) {
            gold[i].children[0].style.lineHeight = height + 'px';
        }
    }

    sum -= 120;

    $('#leistungsumfang .checked i')[0].style.paddingTop = sum / 2 + 'px';
    $('#leistungsumfang .checked i')[0].style.paddingBottom = sum / 2 + 'px';

    $("#gallery").unitegallery({
        gallery_theme: 'tiles',

        tiles_col_width: 370
    });

    update(0);
    updateBoxesHeight();
    updateLineHeight();

    $(window).resize(function() {
        update(0);
    });

    $(window).scroll(function() {
        update(1);
    });

    //$('body').scrollspy({ target: '#navbar' });
});